export default __webpack_public_path__ + "static/media/courseraIndicatorWithoutShadow.25bfc990.svg";